import React, { useEffect, useState } from "react";
import api, { formatErr } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { toast } from "sonner";

export default function AdminSEO() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ page: "home", title: "", description: "", keywords: "", content: "" });

  const load = () => api.get("/admin/seo").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/admin/seo", form); toast.success("Saved"); load(); }
    catch (err) { toast.error(formatErr(err)); }
  };

  const edit = (it) => setForm({ ...it });

  return (
    <div data-testid="admin-seo">
      <h1 className="font-serif-display text-4xl mb-8">SEO Management</h1>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-background rounded-2xl border border-border p-6">
          <h2 className="font-serif-display text-2xl mb-4">Edit SEO</h2>
          <form onSubmit={save} className="space-y-3">
            <div><Label>Page Key</Label><Input required value={form.page} onChange={(e) => setForm({ ...form, page: e.target.value })} placeholder="home, category:birthday, package:slug" data-testid="seo-page" /></div>
            <div><Label>Meta Title</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="seo-title" /></div>
            <div><Label>Meta Description</Label><Textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="seo-desc" /></div>
            <div><Label>Keywords</Label><Input value={form.keywords} onChange={(e) => setForm({ ...form, keywords: e.target.value })} /></div>
            <div><Label>Page Content (300-500 words)</Label><Textarea rows={8} value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} /></div>
            <Button type="submit" className="rounded-full bg-primary w-full" data-testid="seo-save">Save</Button>
          </form>
        </div>
        <div className="bg-background rounded-2xl border border-border p-6">
          <h2 className="font-serif-display text-2xl mb-4">Existing Pages</h2>
          <div className="space-y-2 max-h-[500px] overflow-y-auto">
            {items.map((it) => (
              <button key={it.page} onClick={() => edit(it)} className="block w-full text-left p-3 bg-muted hover:bg-primary/10 rounded-lg" data-testid={`seo-${it.page}`}>
                <div className="text-sm font-medium">{it.page}</div>
                <div className="text-xs text-muted-foreground">{it.title || "(no title)"}</div>
              </button>
            ))}
            {items.length === 0 && <div className="text-sm text-muted-foreground">No SEO entries yet.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
